import { render, staticRenderFns } from "./AwardsListModal.vue?vue&type=template&id=826ae902&scoped=true"
import script from "./AwardsListModal.vue?vue&type=script&lang=js"
export * from "./AwardsListModal.vue?vue&type=script&lang=js"
import style0 from "./AwardsListModal.vue?vue&type=style&index=0&id=826ae902&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826ae902",
  null
  
)

export default component.exports